angular.module('natura').directive('pggFeatureinfo', [ function() {
  return {
    restrict : "E",
    templateUrl : "assets/terkep/app/featureinfo/featureinfo.html",
    replace : true,
    scope : {
      map : "="
    },
    controller : "PggFeatureinfoController",
    controllerAs : "ctrl",
    bindToController : true
  };
} ]);

angular.module('natura').provider("pggFeatureinfoProvider", [ function() {
  /**
   * CONFIG
   */
  var config = {
    map : null,
    clickEvent : null,
    elements : null,
    scope : null
  };

  this.$get = [
      "$http",
      "pggConfigProvider",
      "pggLayerTreeProvider",
      function($http, pggConfigProvider, pggLayerTreeProvider) {
        /**
         * GETTERS AND SETTERS
         */
        var _getMap = function() {
          return config.map;
        };
        var _setMap = function(map) {
          config.map = map;
        };
        var _getScope = function() {
          return config.scope;
        };
        var _setScope = function(scope) {
          config.scope = scope;
        };

        /**
         * FUNCTIONS
         */
        /**
         * A jsonp getfeatureinfo hívás miatt szükség van egy globális
         * függvényre, aminek a neve pont ugyanaz, mint amit a getfeatureinfo
         * hívásba beteszünk
         */
        window.parseGetFeatureInfo = function(data) {
          var elements = [];
          if (data.hasOwnProperty("features") && data.features.length > 0) {
            _getScope().nofeatures = false;
            // TODO: folytatás, jsonp-re átalakítás
            // végigmegy az elemeken
            angular.forEach(data.features, function(feature) {
              var elemObj = {};
              // kulcs-érték párokat kiszedi
              for ( var key in feature.properties) {
                if (feature.properties.hasOwnProperty(key)) {
                  elemObj[key] = feature.properties[key];
                }
              }
              elements.push(elemObj);
            });
          } else {
            _getScope().nofeatures = true;
          }
          // befrissíti a $scope.elements objektumot
          _getScope().elements = elements;
        };

        /**
         * GetFeatureInfo hívás elküldése
         */
        var _createGetFeatureInfoUrlPromise = function(url) {
          var promise = $http.jsonp(url).then(function(response) {
            return response;
          });
          return promise;
        };

        /**
         * Térképre kattintás esemény aktiválása, getfeatureinfo hívás
         * összeállítása és meghívása
         */
        var _activateClick = function(layer) {
          // először kipucolom a click eseményt, biztos ami biztos
          _deactivateClick();
          config.clickEvent = config.map.on("singleclick", function(evt) {
            var viewResolution = config.map.getView().getResolution();
            // getfeatureinfo url összeállítása, jsonp típussal, callback
            // beállításával
            var url = layer.getSource().getGetFeatureInfoUrl(evt.coordinate, viewResolution,
                pggConfigProvider.getSrs(), {
                  "INFO_FORMAT" : "text/javascript",
                  "FORMAT_OPTIONS" : "callback:parseGetFeatureInfo"
                });
            if (url) {
              // feature info kérés elküldése
              _createGetFeatureInfoUrlPromise(url).then(function(data) {
              });
            }
          });
        };

        /**
         * Térképre kattintás esemény deaktiválása
         */
        var _deactivateClick = function() {
          _getScope().nofeatures = false;
          _getScope().elements = [];
          config.map.unByKey(config.clickEvent);
        };

        /**
         * Deaktiválás + réteg legördülő alapállapotra helyezése
         */
        var _resetClick = function() {
          _getScope().layers.selected = null;
          _deactivateClick();
        };

        /**
         * RETURNS
         */
        return {
          getMap : _getMap,
          setMap : _setMap,
          getScope : _getScope,
          setScope : _setScope,
          activateClick : _activateClick,
          deactivateClick : _deactivateClick,
          resetClick : _resetClick
        };
      } ];
} ]);

angular.module('natura').controller('PggFeatureinfoController', [
    '$scope',
    '$http',
    'pggFeatureinfoProvider',
    'pggLayerTreeProvider',
    function($scope, $http, pggFeatureinfoProvider, pggLayerTreeProvider) {
      $scope.map = this.map;

      pggFeatureinfoProvider.setMap($scope.map);

      $scope.elements = [];
      $scope.nofeatures = false;
      pggFeatureinfoProvider.setScope($scope);

      $scope.layers = [];
      angular.forEach(pggLayerTreeProvider.getLayersFromLayerGroup(pggLayerTreeProvider.getLayerGroupTypes().overlays),
          function(layer) {
            if (layer.getSource() instanceof ol.source.TileWMS) {
              $scope.layers.push({
                value : layer.get("name"),
                obj : layer
              });
            }
          });

      $scope.activateToolWithLayer = function() {
        pggFeatureinfoProvider.activateClick($scope.layers.selected.obj);
      };

    } ]);
